export enum RenovationView {
  Dashboard = 'dashboard',

  WarehousesList = 'warehousesList',
  WarehousesNew = 'warehousesNew',
  WarehousesFilter = 'warehousesFilter',
  WarehousesEdit = 'warehousesEdit',

  DrawersList = 'drawersList',
  DrawersNew = 'drawersNew',
  DrawersFilter = 'drawersFilter',
  DrawersEdit = 'drawersEdit',

  HousekeysList = 'housekeysList',
  HousekeysNew = 'housekeysNew',
  HousekeysFilter = 'housekeysFilter',
  HousekeysEdit = 'housekeysEdit',

  UsersList = 'usersList',
  UsersNew = 'usersNew',
  UsersFilter = 'usersFilter',
  UsersEdit = 'usersEdit',

  LoansList = 'loansList',
  LoansNew = 'loansNew',

  PropertiesList = 'PropertiesList',
  PropertiesNew = 'PropertiesNew',
  PropertiesEdit = 'PropertiesEdit',
  PropertiesFilter = 'PropertiesFilter',

  RepaymentsNew = 'RepaymentsNew',
  LoansP2PNew = 'LoansP2PNew',
  LoansP2PList = 'LoansP2PList',
}
